/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_Ai_Stage_DiscoverInputs */

const en_directory_hubs_signals_ai_stage_discover = /** @type {(inputs: Directory_Hubs_Signals_Ai_Stage_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`llms.txt and sitemap declarations — the signals agents use to find a product's machine-readable entry points. 2 checks.`)
};

const zh_directory_hubs_signals_ai_stage_discover = /** @type {(inputs: Directory_Hubs_Signals_Ai_Stage_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`llms.txt 与 sitemap 声明——Agent 靠它们发现产品的机器可读入口。2 项检查。`)
};

/**
* | output |
* | --- |
* | "llms.txt and sitemap declarations — the signals agents use to find a product's machine-readable entry points. 2 checks." |
*
* @param {Directory_Hubs_Signals_Ai_Stage_DiscoverInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_ai_stage_discover = /** @type {((inputs?: Directory_Hubs_Signals_Ai_Stage_DiscoverInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_Ai_Stage_DiscoverInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_ai_stage_discover(inputs)
	return zh_directory_hubs_signals_ai_stage_discover(inputs)
});
export { directory_hubs_signals_ai_stage_discover as "directory.hubs.signals.ai.stage.discover" }